<script>
/* eslint-disable camelcase */
import Axios from 'axios'

const isProduction = process.env.NODE_ENV === 'production'

const base_url = isProduction
  ? 'https://happytrain.co.kr:6464/'
  : 'http://localhost:6464/'

export const base_url_export = isProduction
  ? 'https://happytrain.co.kr:6464/'
  : 'http://localhost:6464/'

const base_homepage_url = isProduction
  ? 'https://happytrain.co.kr/'
  : 'http://localhost:3000/'

export const base_homepage_url_export = isProduction
  ? 'https://happytrain.co.kr/'
  : 'http://localhost:3000/'

export const inicis_export = isProduction
  ? 'html5_inicis.MOItrain01'
  : 'html5_inicis.INIpayTest'

export const buildStatus = isProduction
  ? 'operation'
  : 'test'

export const defaultFunction = () => {
  return ''
}

export const check_login_admin = async (
  admin_login_ID,
  admin_password
) => {
  let data = new FormData()

  data.append('admin_login_ID', admin_login_ID)
  data.append('admin_password', admin_password)

  try {
    const response = await Axios.post(
      `${base_url}login/check_login_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_session_admin = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}login/get_session_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_menu_permission = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_menu_permission`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_menu_permission_one = async (
  menu_permission_ID
) => {
  let data = new FormData()
  data.append('menu_permission_ID', menu_permission_ID)
  try {
    const response = await Axios.post(
      `${base_url}system/get_menu_permission_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_menu_permission_status_1 = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_menu_permission_status_1`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_menu_permission = async (
  menu_permission_name,
  menu_permission_status,
  menu_permission_array
) => {
  let data = new FormData()
  data.append('menu_permission_name', menu_permission_name)
  data.append('menu_permission_status', menu_permission_status)
  data.append('menu_permission_array', menu_permission_array)

  try {
    const response = await Axios.post(
      `${base_url}system/insert_menu_permission`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_menu_permission = async (
  menu_permission_ID,
  menu_permission_name,
  menu_permission_status,
  menu_permission_array
) => {
  let data = new FormData()
  data.append('menu_permission_ID', menu_permission_ID)
  data.append('menu_permission_name', menu_permission_name)
  data.append('menu_permission_status', menu_permission_status)
  data.append('menu_permission_array', menu_permission_array)

  try {
    const response = await Axios.post(
      `${base_url}system/update_menu_permission`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_homepage_menu = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_homepage_menu`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_admin = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_admin_one = async (
  admin_ID
) => {
  let data = new FormData()
  data.append('admin_ID', admin_ID)
  try {
    const response = await Axios.post(
      `${base_url}system/get_admin_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_admin = async (
  menu_permission_ID_admin,
  admin_login_ID,
  admin_password,
  admin_name,
  admin_activate
) => {
  let data = new FormData()
  data.append('menu_permission_ID_admin', menu_permission_ID_admin)
  data.append('admin_login_ID', admin_login_ID)
  data.append('admin_password', admin_password)
  data.append('admin_name', admin_name)
  data.append('admin_activate', admin_activate)

  try {
    const response = await Axios.post(
      `${base_url}system/insert_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_admin = async (
  admin_ID,
  menu_permission_ID_admin,
  admin_login_ID,
  admin_password,
  admin_name,
  admin_activate
) => {
  let data = new FormData()
  data.append('admin_ID', admin_ID)
  data.append('menu_permission_ID_admin', menu_permission_ID_admin)
  data.append('admin_login_ID', admin_login_ID)
  data.append('admin_password', admin_password)
  data.append('admin_name', admin_name)
  data.append('admin_activate', admin_activate)

  try {
    const response = await Axios.post(
      `${base_url}system/update_admin`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_hot_keyword_top10 = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}system/get_hot_keyword_top10`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_hot_keyword = async (
  hot_keyword_ID,
  hot_keyword_count,
  hot_keyword_status
) => {
  let data = new FormData()
  data.append('hot_keyword_ID', hot_keyword_ID)
  data.append('hot_keyword_count', hot_keyword_count)
  data.append('hot_keyword_status', hot_keyword_status)

  try {
    const response = await Axios.post(
      `${base_url}system/update_hot_keyword`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const count_hot_keyword = async (
  hot_keyword_name
) => {
  let data = new FormData()
  data.append('hot_keyword_name', hot_keyword_name)

  try {
    const response = await Axios.post(
      `${base_url}system/count_hot_keyword`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_editor_image = async (
  editor_file
) => {
  let data = new FormData()
  data.append('editor_file', editor_file.blob())

  try {
    const response = await Axios.post(
      `${base_url}system/insert_editor_image`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    // 에디터가 업로드 실패를 사용자에게 표시할 수 있도록 오류를 호출부로 전달한다.
    throw err
  }
}

export const get_editor_one = async (editor_division) => {
  let data = new FormData()
  data.append('editor_division', editor_division)

  try {
    const response = await Axios.post(
      `${base_url}system/get_editor_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_editor = async (
  editor_ID,
  editor_content,
  editor_content_mobile
) => {
  let data = new FormData()
  data.append('editor_ID', editor_ID)
  data.append('editor_content', editor_content)
  data.append('editor_content_mobile', editor_content_mobile)

  try {
    const response = await Axios.post(
      `${base_url}system/update_editor`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const send_sns = async (
  receiver,
  message
) => {
  let data = new FormData()
  data.append('receiver', receiver)
  data.append('message', message)

  try {
    const response = await Axios.post(
      `${base_url}system/send_sns`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const send_sns_multi = async (
  multi_receiver,
  message
) => {
  let data = new FormData()
  data.append('multi_receiver', multi_receiver)
  data.append('message', message)

  try {
    const response = await Axios.post(
      `${base_url}system/send_sns_multi`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_message_log_all = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}system/get_message_log_all`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_point_log_all = async (admin_number) => {
  let data = new FormData()
  data.append('admin_number', admin_number)

  try {
    const response = await Axios.post(
      `${base_url}system/get_point_log_all`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_point_log = async (
  customer_ID_use_point_log
) => {
  let data = new FormData()
  data.append('customer_ID_use_point_log', customer_ID_use_point_log)

  try {
    const response = await Axios.post(
      `${base_url}system/get_point_log`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_point_sum = async (
  customer_ID_use_point_log
) => {
  let data = new FormData()
  data.append('customer_ID_use_point_log', customer_ID_use_point_log)

  try {
    const response = await Axios.post(
      `${base_url}system/get_point_sum`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const add_point = async (
  customer_ID_use_point_log,
  point_log_point
) => {
  let data = new FormData()
  data.append('customer_ID_use_point_log', customer_ID_use_point_log)
  data.append('point_log_point', point_log_point)

  try {
    const response = await Axios.post(
      `${base_url}system/add_point`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_popup = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_popup`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_popup_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}system/get_popup_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_popup_one = async (
  popup_ID
) => {
  let data = new FormData()
  data.append('popup_ID', popup_ID)
  try {
    const response = await Axios.post(
      `${base_url}system/get_popup_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_popup = async (
  popup_name,
  popup_image,
  popup_link,
  popup_status
) => {
  let data = new FormData()
  data.append('popup_name', popup_name)
  data.append('popup_image', popup_image)
  data.append('popup_link', popup_link)
  data.append('popup_status', popup_status)

  try {
    const response = await Axios.post(
      `${base_url}system/insert_popup`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_popup = async (
  popup_ID,
  popup_name,
  popup_image,
  popup_link,
  popup_status
) => {
  let data = new FormData()
  data.append('popup_ID', popup_ID)
  data.append('popup_name', popup_name)
  data.append('popup_image', popup_image)
  data.append('popup_link', popup_link)
  data.append('popup_status', popup_status)

  try {
    const response = await Axios.post(
      `${base_url}system/update_popup`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_popup_order = async (
  popup_order_array
) => {
  let data = new FormData()

  data.append('popup_order_array', JSON.stringify(popup_order_array))
  try {
    const response = await Axios.post(
      `${base_url}system/update_popup_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_popup = async (
  popup_ID_array
) => {
  let data = new FormData()
  data.append('popup_ID_array', popup_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}system/delete_popup`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_benefits = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}system/get_benefits`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_benefits = async (
  benefits_join_point
) => {
  let data = new FormData()
  data.append('benefits_join_point', benefits_join_point)

  try {
    const response = await Axios.post(
      `${base_url}system/update_benefits`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}
export const check_customer_login_ID = async (
  customer_login_ID
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)

  try {
    const response = await Axios.post(
      `${base_url}login/check_customer_login_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_customer = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))
  try {
    const response = await Axios.post(
      `${base_url}login/get_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_customer_one = async (
  customer_ID
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  try {
    const response = await Axios.post(
      `${base_url}login/get_customer_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_customer_search = async (search_data) => {
  let data = new FormData()
  data.append('search_data', search_data)

  try {
    const response = await Axios.post(
      `${base_url}login/get_customer_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_customer = async (
  customer_ID,
  customer_super_status,
  customer_login_ID,
  customer_password,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_gender,
  customer_zip_code,
  customer_road_address,
  customer_detail_address,
  customer_big_area,
  customer_small_area,
  customer_activate
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_super_status', customer_super_status)
  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_gender', customer_gender)
  data.append('customer_zip_code', customer_zip_code)
  data.append('customer_road_address', customer_road_address)
  data.append('customer_detail_address', customer_detail_address)
  data.append('customer_big_area', customer_big_area)
  data.append('customer_small_area', customer_small_area)
  data.append('customer_activate', customer_activate)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_customer_management = async (
  customer_login_ID,
  customer_password,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_privacy_status,
  customer_service_agreement_status,
  customer_marketing_status
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_privacy_status', customer_privacy_status)
  data.append('customer_service_agreement_status', customer_service_agreement_status)
  data.append('customer_marketing_status', customer_marketing_status)

  try {
    const response = await Axios.post(
      `${base_url}login/insert_customer_management`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_customer_management = async (
  customer_ID,
  customer_password,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_marketing_status
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_password', customer_password)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_marketing_status', customer_marketing_status)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer_management`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}
export const update_customer_easy_join_management = async (
  customer_ID,
  customer_name,
  customer_phone_number,
  customer_email,
  customer_privacy_status,
  customer_service_agreement_status,
  customer_marketing_status
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)
  data.append('customer_email', customer_email)
  data.append('customer_privacy_status', customer_privacy_status)
  data.append('customer_service_agreement_status', customer_service_agreement_status)
  data.append('customer_marketing_status', customer_marketing_status)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer_easy_join_management`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_customer_secession = async (
  customer_ID,
  customer_secession_reason
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('customer_secession_reason', customer_secession_reason)

  try {
    const response = await Axios.post(
      `${base_url}login/update_customer_secession`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_login = async (
  customer_login_ID,
  customer_password
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)

  try {
    const response = await Axios.post(
      `${base_url}login/check_login`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_kakao_token = async (code) => {
  try {
    const response = await Axios.post(
      `https://kauth.kakao.com/oauth/token`,
      {},
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        params: {
          grant_type: 'authorization_code',
          client_id: '09c5eb1e59461c0210d2029fa7e09651',
          code: code,
          redirect_uri: base_homepage_url + 'KaKaoLogin'
        }
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_kakao_login_data = async (token) => {
  try {
    const response = await Axios.post(
      'https://kapi.kakao.com/v2/user/me',
      {},
      {
        headers: {
          Authorization: `Bearer ${token.access_token}`
        }
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_kakao_login = async (
  customer_kakao_ID,
  customer_email,
  customer_name
) => {
  let data = new FormData()
  data.append('customer_kakao_ID', customer_kakao_ID)
  data.append('customer_email', customer_email)
  data.append('customer_name', customer_name)

  try {
    const response = await Axios.post(
      `${base_url}login/check_kakao_login`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_naver_token = async (code) => {
  let data = new FormData()
  data.append('code', code)

  try {
    const response = await Axios.post(
      `${base_url}login/get_naver_token`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_secession = async (
  customer_login_ID,
  customer_password
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_password', customer_password)

  try {
    const response = await Axios.post(
      `${base_url}login/check_secession`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const search_customer_ID = async (
  customer_name,
  customer_phone_number
) => {
  let data = new FormData()

  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)

  try {
    const response = await Axios.post(
      `${base_url}login/search_customer_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const search_customer_password = async (
  customer_login_ID,
  customer_name,
  customer_phone_number
) => {
  let data = new FormData()

  data.append('customer_login_ID', customer_login_ID)
  data.append('customer_name', customer_name)
  data.append('customer_phone_number', customer_phone_number)

  try {
    const response = await Axios.post(
      `${base_url}login/search_customer_password`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const set_temporary_password = async (
  customer_login_ID,
  temporary_password
) => {
  let data = new FormData()
  data.append('customer_login_ID', customer_login_ID)
  data.append('temporary_password', temporary_password)

  try {
    const response = await Axios.post(
      `${base_url}login/set_temporary_password`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_session_customer = async (
) => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}login/get_session_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_session_customer = async (
) => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}login/delete_session_customer`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_rolling_banner = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_rolling_banner_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_rolling_banner_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_rolling_banner_one = async (
  rolling_banner_ID
) => {
  let data = new FormData()
  data.append('rolling_banner_ID', rolling_banner_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_rolling_banner_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_rolling_banner = async (
  rolling_banner_name,
  rolling_banner_image,
  rolling_banner_image_mobile,
  rolling_banner_link
) => {
  let data = new FormData()
  data.append('rolling_banner_name', rolling_banner_name)
  data.append('rolling_banner_image', rolling_banner_image)
  data.append('rolling_banner_image_mobile', rolling_banner_image_mobile)
  data.append('rolling_banner_link', rolling_banner_link)

  try {
    const response = await Axios.post(
      `${base_url}main/insert_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_rolling_banner = async (
  rolling_banner_ID,
  rolling_banner_name,
  rolling_banner_image,
  rolling_banner_image_mobile,
  rolling_banner_link,
  rolling_banner_status
) => {
  let data = new FormData()
  data.append('rolling_banner_ID', rolling_banner_ID)
  data.append('rolling_banner_name', rolling_banner_name)
  data.append('rolling_banner_image', rolling_banner_image)
  data.append('rolling_banner_image_mobile', rolling_banner_image_mobile)
  data.append('rolling_banner_link', rolling_banner_link)
  data.append('rolling_banner_status', rolling_banner_status)

  try {
    const response = await Axios.post(
      `${base_url}main/update_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_rolling_banner_order = async (
  rolling_banner_order_array
) => {
  let data = new FormData()

  data.append('rolling_banner_order_array', JSON.stringify(rolling_banner_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_rolling_banner_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_rolling_banner = async (
  rolling_banner_ID_array
) => {
  let data = new FormData()
  data.append('rolling_banner_ID_array', rolling_banner_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_rolling_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_banner = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_banner_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_banner_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_banner_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_banner_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_banner_one = async (
  recommend_banner_ID
) => {
  let data = new FormData()
  data.append('recommend_banner_ID', recommend_banner_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_banner_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_banner_one_use = async (
  recommend_banner_ID
) => {
  let data = new FormData()
  data.append('recommend_banner_ID', recommend_banner_ID)
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_banner_one_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_recommend_banner = async (
  recommend_banner_title,
  recommend_banner_link,
  recommend_banner_main_image,
  recommend_banner_status,
  recommend_banner_main_status
) => {
  let data = new FormData()
  data.append('recommend_banner_title', recommend_banner_title)
  data.append('recommend_banner_link', recommend_banner_link)
  data.append('recommend_banner_main_image', recommend_banner_main_image)
  data.append('recommend_banner_status', recommend_banner_status)
  data.append('recommend_banner_main_status', recommend_banner_main_status)

  try {
    const response = await Axios.post(
      `${base_url}main/insert_recommend_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recommend_banner = async (
  recommend_banner_ID,
  recommend_banner_title,
  recommend_banner_link,
  recommend_banner_main_image,
  recommend_banner_status,
  recommend_banner_main_status
) => {
  let data = new FormData()
  data.append('recommend_banner_ID', recommend_banner_ID)
  data.append('recommend_banner_title', recommend_banner_title)
  data.append('recommend_banner_link', recommend_banner_link)
  data.append('recommend_banner_main_image', recommend_banner_main_image)
  data.append('recommend_banner_status', recommend_banner_status)
  data.append('recommend_banner_main_status', recommend_banner_main_status)

  try {
    const response = await Axios.post(
      `${base_url}main/update_recommend_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recommend_banner_order = async (
  recommend_banner_order_array
) => {
  let data = new FormData()

  data.append('recommend_banner_order_array', JSON.stringify(recommend_banner_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_recommend_banner_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_recommend_banner = async (
  recommend_banner_ID_array
) => {
  let data = new FormData()
  data.append('recommend_banner_ID_array', recommend_banner_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_recommend_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_month_banner = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_month_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_month_banner_main_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_month_banner_main_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_recommend_month_banner_search = async (
  search_input_data
) => {
  let data = new FormData()
  data.append('search_input_data', search_input_data)

  try {
    const response = await Axios.post(
      `${base_url}main/get_recommend_month_banner_search`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_recommend_month_banner_one = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}main/insert_recommend_month_banner_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recommend_month_banner = async (
  recommend_month_banner_ID,
  product_ID
) => {
  let data = new FormData()

  data.append('recommend_month_banner_ID', recommend_month_banner_ID)
  data.append('product_ID', String(product_ID))

  try {
    const response = await Axios.post(
      `${base_url}main/update_recommend_month_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recommend_month_banner_status = async (
  recommend_month_banner_ID,
  recommend_month_banner_status
) => {
  let data = new FormData()

  data.append('recommend_month_banner_ID', recommend_month_banner_ID)
  data.append('recommend_month_banner_status', String(recommend_month_banner_status))

  try {
    const response = await Axios.post(
      `${base_url}main/update_recommend_month_banner_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_recommend_month_banner_order = async (
  recommend_month_banner_order_array
) => {
  let data = new FormData()

  data.append('recommend_month_banner_order_array', JSON.stringify(recommend_month_banner_order_array))
  try {
    const response = await Axios.post(
      `${base_url}main/update_recommend_month_banner_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_recommend_month_banner = async (
  recommend_month_banner_ID_array
) => {
  let data = new FormData()
  data.append('recommend_month_banner_ID_array', recommend_month_banner_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}main/delete_recommend_month_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_fix_banner_all = async () => {
  let data = new FormData()

  try {
    const response = await Axios.post(
      `${base_url}main/get_fix_banner_all`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_fix_banner = async (
  fix_banner_title_1,
  fix_banner_link_1,
  fix_banner_image_1
) => {
  let data = new FormData()
  data.append('fix_banner_title_1', fix_banner_title_1)
  data.append('fix_banner_link_1', fix_banner_link_1)
  data.append('fix_banner_image_1', fix_banner_image_1)

  try {
    const response = await Axios.post(
      `${base_url}main/update_fix_banner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_type = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_type_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_type_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_type_use_where = async (
  travel_type_division
) => {
  const data = new FormData()
  data.append('travel_type_division', travel_type_division)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_type_use_where`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_type_one = async (
  travel_type_ID
) => {
  let data = new FormData()
  data.append('travel_type_ID', travel_type_ID)
  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_type_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_travel_type = async (
  travel_type_division,
  travel_type_name,
  travel_type_status
) => {
  let data = new FormData()
  data.append('travel_type_division', travel_type_division)
  data.append('travel_type_name', travel_type_name)
  data.append('travel_type_status', travel_type_status)

  try {
    const response = await Axios.post(
      `${base_url}travel/insert_travel_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_type = async (
  travel_type_ID,
  travel_type_division,
  travel_type_name,
  travel_type_status
) => {
  let data = new FormData()
  data.append('travel_type_ID', travel_type_ID)
  data.append('travel_type_division', travel_type_division)
  data.append('travel_type_name', travel_type_name)
  data.append('travel_type_status', travel_type_status)

  try {
    const response = await Axios.post(
      `${base_url}travel/update_travel_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_type_order = async (
  travel_type_order_array
) => {
  let data = new FormData()

  data.append('travel_type_order_array', JSON.stringify(travel_type_order_array))
  try {
    const response = await Axios.post(
      `${base_url}travel/update_travel_type_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_travel_type = async (
  travel_type_ID_array
) => {
  let data = new FormData()
  data.append('travel_type_ID_array', travel_type_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}travel/delete_travel_type`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_use_where = async (
  travel_type_division
) => {
  const data = new FormData()
  data.append('travel_type_division', travel_type_division)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_use_where`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_use_main = async (
  travel_type_division
) => {
  const data = new FormData()
  data.append('travel_type_division', travel_type_division)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_use_main`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_one = async (
  travel_product_ID
) => {
  let data = new FormData()
  data.append('travel_product_ID', travel_product_ID)
  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_homepage = async (
  travel_type_ID,
  travel_type_division,
  search_data,
  departure_confirmed,
  current_page,
  page_size
) => {
  let data = new FormData()
  data.append('travel_type_ID', travel_type_ID)
  data.append('travel_type_division', travel_type_division)
  data.append('search_data', search_data)
  data.append('departure_confirmed', departure_confirmed)
  data.append('current_page', current_page)
  data.append('page_size', page_size)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_homepage`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_recommend = async (
  travel_type_division
) => {
  let data = new FormData()
  data.append('travel_type_division', travel_type_division)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_recommend`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_product_interest = async (
  travel_type_division
) => {
  let data = new FormData()
  data.append('travel_type_division', travel_type_division)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_travel_product_interest`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_travel_product = async (
  travel_type_ID_use_travel_product,
  travel_product_tag,
  travel_product_name,
  travel_product_night,
  travel_product_day,
  travel_product_point,
  travel_product_minimum_departure,
  travel_product_gather_place,
  travel_product_travel_cource,
  travel_product_included,
  travel_product_included_not,
  travel_product_info,
  travel_product_recommend_status,
  travel_product_main_status,
  travel_product_status,
  travel_product_image,
  travel_product_caution,
  travel_product_cancel_refund,
  schedule_time_array
) => {
  let data = new FormData()
  data.append('travel_type_ID_use_travel_product', travel_type_ID_use_travel_product)
  data.append('travel_product_tag', travel_product_tag)
  data.append('travel_product_name', travel_product_name)
  data.append('travel_product_night', travel_product_night)
  data.append('travel_product_day', travel_product_day)
  data.append('travel_product_point', travel_product_point)
  data.append('travel_product_minimum_departure', travel_product_minimum_departure)
  data.append('travel_product_gather_place', travel_product_gather_place)
  data.append('travel_product_travel_cource', travel_product_travel_cource)
  data.append('travel_product_included', travel_product_included)
  data.append('travel_product_included_not', travel_product_included_not)
  data.append('travel_product_info', travel_product_info)
  data.append('travel_product_recommend_status', travel_product_recommend_status)
  data.append('travel_product_main_status', travel_product_main_status)
  data.append('travel_product_status', travel_product_status)
  travel_product_image.forEach((image, index) => {
    if (image.file) {
      data.append(`travel_product_img${index + 1}`, image.file)
    }
  })
  data.append('travel_product_caution', travel_product_caution)
  data.append('travel_product_cancel_refund', travel_product_cancel_refund)
  data.append('schedule_time_array', JSON.stringify(schedule_time_array))
  try {
    const response = await Axios.post(
      `${base_url}travel/insert_travel_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_product = async (
  travel_product_ID,
  travel_type_ID_use_travel_product,
  travel_product_tag,
  travel_product_name,
  travel_product_night,
  travel_product_day,
  travel_product_point,
  travel_product_minimum_departure,
  travel_product_gather_place,
  travel_product_travel_cource,
  travel_product_included,
  travel_product_included_not,
  travel_product_info,
  travel_product_recommend_status,
  travel_product_main_status,
  travel_product_status,
  travel_product_image,
  travel_product_caution,
  travel_product_cancel_refund,
  schedule_time_array
) => {
  let data = new FormData()
  data.append('travel_product_ID', travel_product_ID)
  data.append('travel_type_ID_use_travel_product', travel_type_ID_use_travel_product)
  data.append('travel_product_tag', travel_product_tag)
  data.append('travel_product_name', travel_product_name)
  data.append('travel_product_night', travel_product_night)
  data.append('travel_product_day', travel_product_day)
  data.append('travel_product_point', travel_product_point)
  data.append('travel_product_minimum_departure', travel_product_minimum_departure)
  data.append('travel_product_gather_place', travel_product_gather_place)
  data.append('travel_product_travel_cource', travel_product_travel_cource)
  data.append('travel_product_included', travel_product_included)
  data.append('travel_product_included_not', travel_product_included_not)
  data.append('travel_product_info', travel_product_info)
  data.append('travel_product_recommend_status', travel_product_recommend_status)
  data.append('travel_product_main_status', travel_product_main_status)
  data.append('travel_product_status', travel_product_status)
  travel_product_image.forEach((image, index) => {
    if (image.file) {
      data.append(`travel_product_img${index + 1}`, image.file)
    } else {
      data.append(`travel_product_img${index + 1}`, image.url)
    }
  })
  data.append('travel_product_caution', travel_product_caution)
  data.append('travel_product_cancel_refund', travel_product_cancel_refund)
  data.append('schedule_time_array', JSON.stringify(schedule_time_array))
  try {
    const response = await Axios.post(
      `${base_url}travel/update_travel_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_product_order = async (
  travel_product_order_array
) => {
  let data = new FormData()

  data.append('travel_product_order_array', JSON.stringify(travel_product_order_array))
  try {
    const response = await Axios.post(
      `${base_url}travel/update_travel_product_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const copy_travel_product = async (
  travel_product_ID_array
) => {
  let data = new FormData()
  data.append('travel_product_ID_array', travel_product_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}travel/copy_travel_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_travel_product = async (
  travel_product_ID_array
) => {
  let data = new FormData()
  data.append('travel_product_ID_array', travel_product_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}travel/delete_travel_product`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_schedule = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))

  try {
    const response = await Axios.post(
      `${base_url}travel/get_schedule`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_schedule_day = async (
  travel_product_ID_use_schedule,
  schedule_start_month,
  schedule_end_month
) => {
  let data = new FormData()
  data.append('travel_product_ID_use_schedule', travel_product_ID_use_schedule)
  data.append('schedule_start_month', schedule_start_month)
  data.append('schedule_end_month', schedule_end_month)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_schedule_day`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_schedule_one = async (
  schedule_ID
) => {
  let data = new FormData()
  data.append('schedule_ID', schedule_ID)
  try {
    const response = await Axios.post(
      `${base_url}travel/get_schedule_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const check_schedule_day = async (
  travel_product_ID_use_schedule
) => {
  let data = new FormData()
  data.append('travel_product_ID_use_schedule', travel_product_ID_use_schedule)

  try {
    const response = await Axios.post(
      `${base_url}travel/check_schedule_day`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_schedule = async (
  travel_product_ID_use_schedule,
  schedule_start_day,
  schedule_end_day,
  schedule_boarding,
  schedule_price,
  schedule_price_child,
  schedule_seats,
  schedule_status,
  schedule_option_use_status,
  schedule_group_option_status,
  schedule_group_option_title,
  schedule_group_option_array,
  schedule_option_array
) => {
  let data = new FormData()
  data.append('travel_product_ID_use_schedule', travel_product_ID_use_schedule)
  data.append('schedule_start_day', schedule_start_day)
  data.append('schedule_end_day', schedule_end_day)
  data.append('schedule_boarding', schedule_boarding)
  data.append('schedule_price', schedule_price)
  data.append('schedule_price_child', schedule_price_child)
  data.append('schedule_seats', schedule_seats)
  data.append('schedule_status', schedule_status)
  data.append('schedule_option_use_status', schedule_option_use_status)
  data.append('schedule_group_option_status', schedule_group_option_status)
  data.append('schedule_group_option_title', schedule_group_option_title)
  data.append('schedule_group_option_array', schedule_group_option_array)
  data.append('schedule_option_array', schedule_option_array)
  try {
    const response = await Axios.post(
      `${base_url}travel/insert_schedule`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_schedule = async (
  schedule_ID,
  travel_product_ID_use_schedule,
  schedule_start_day,
  schedule_end_day,
  schedule_boarding,
  schedule_price,
  schedule_price_child,
  schedule_seats,
  schedule_status,
  schedule_option_use_status,
  schedule_group_option_status,
  schedule_group_option_title,
  schedule_group_option_array,
  schedule_option_array
) => {
  let data = new FormData()
  data.append('schedule_ID', schedule_ID)
  data.append('travel_product_ID_use_schedule', travel_product_ID_use_schedule)
  data.append('schedule_start_day', schedule_start_day)
  data.append('schedule_end_day', schedule_end_day)
  data.append('schedule_boarding', schedule_boarding)
  data.append('schedule_price', schedule_price)
  data.append('schedule_price_child', schedule_price_child)
  data.append('schedule_seats', schedule_seats)
  data.append('schedule_status', schedule_status)
  data.append('schedule_option_use_status', schedule_option_use_status)
  data.append('schedule_group_option_status', schedule_group_option_status)
  data.append('schedule_group_option_title', schedule_group_option_title)
  data.append('schedule_group_option_array', schedule_group_option_array)
  data.append('schedule_option_array', schedule_option_array)
  try {
    const response = await Axios.post(
      `${base_url}travel/update_schedule`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const copy_schedule = async (
  schedule_ID_array
) => {
  let data = new FormData()
  data.append('schedule_ID_array', schedule_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}travel/copy_schedule`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_schedule_seats = async (schedule_ID) => {
  let data = new FormData()
  data.append('schedule_ID', schedule_ID)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_schedule_seats`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_schedule_option_seats = async (schedule_ID) => {
  let data = new FormData()
  data.append('schedule_ID', schedule_ID)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_schedule_option_seats`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_interest_travel = async (
  travel_product_ID_use_interest_travel,
  customer_ID_use_interest_travel
) => {
  let data = new FormData()
  data.append('travel_product_ID_use_interest_travel', travel_product_ID_use_interest_travel)
  data.append('customer_ID_use_interest_travel', customer_ID_use_interest_travel)

  try {
    const response = await Axios.post(
      `${base_url}travel/insert_interest_travel`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_interest_travel = async (
  interest_travel_ID
) => {
  let data = new FormData()
  data.append('interest_travel_ID', interest_travel_ID)

  try {
    const response = await Axios.post(
      `${base_url}travel/delete_interest_travel`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_interest_travel_customer_ID = async (
  customer_ID_use_interest_travel
) => {
  let data = new FormData()
  data.append('customer_ID_use_interest_travel', customer_ID_use_interest_travel)

  try {
    const response = await Axios.post(
      `${base_url}travel/get_interest_travel_customer_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_reservation = async (
  customer_ID_use_reservation,
  reservation_customer_name,
  reservation_customer_phone_number,
  reservation_customer_phone_number_2,
  reservation_customer_email,
  reservation_expected_payment_amount,
  reservation_payment_amount,
  reservation_accumulated_points,
  reservation_use_points,
  reservation_payment_method,
  reservation_depositor_name,
  reservation_cash_receipt_request,
  reservation_request,
  reservation_terms_of_use,
  reservation_privacy_statement,
  reservation_electronic_terms_and_conditions,
  reservationDataArray,
  reservationSeatArray,
  imp_uid,
  merchant_uid,
  reservation_number_price,
  reservation_number_price_child
) => {
  let data = new FormData()
  data.append('customer_ID_use_reservation', customer_ID_use_reservation)
  data.append('reservation_customer_name', reservation_customer_name)
  data.append('reservation_customer_phone_number', reservation_customer_phone_number)
  data.append('reservation_customer_phone_number_2', reservation_customer_phone_number_2)
  data.append('reservation_customer_email', reservation_customer_email)
  data.append('reservation_expected_payment_amount', reservation_expected_payment_amount)
  data.append('reservation_payment_amount', reservation_payment_amount)
  data.append('reservation_accumulated_points', reservation_accumulated_points)
  data.append('reservation_use_points', reservation_use_points)
  data.append('reservation_payment_method', reservation_payment_method)
  data.append('reservation_depositor_name', reservation_depositor_name)
  data.append('reservation_cash_receipt_request', reservation_cash_receipt_request)
  data.append('reservation_request', reservation_request)
  data.append('reservation_terms_of_use', reservation_terms_of_use)
  data.append('reservation_privacy_statement', reservation_privacy_statement)
  data.append('reservation_electronic_terms_and_conditions', reservation_electronic_terms_and_conditions)
  data.append('reservationDataArray', JSON.stringify(reservationDataArray))
  data.append('reservationSeatArray', JSON.stringify(reservationSeatArray))
  data.append('imp_uid', imp_uid)
  data.append('merchant_uid', merchant_uid)
  data.append('reservation_number_price', reservation_number_price)
  data.append('reservation_number_price_child', reservation_number_price_child)

  try {
    const response = await Axios.post(
      `${base_url}reservation/insert_reservation`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_reservation_immediate = async (
  reservation_customer_name,
  reservation_customer_phone_number,
  reservation_customer_phone_number_2,
  reservation_customer_email,
  reservation_payment_amount,
  reservation_payment_method,
  reservation_depositor_name,
  reservation_cash_receipt_request,
  reservation_request,
  reservation_terms_of_use,
  reservation_privacy_statement,
  reservation_electronic_terms_and_conditions,
  imp_uid,
  merchant_uid
) => {
  let data = new FormData()
  data.append('reservation_customer_name', reservation_customer_name)
  data.append('reservation_customer_phone_number', reservation_customer_phone_number)
  data.append('reservation_customer_phone_number_2', reservation_customer_phone_number_2)
  data.append('reservation_customer_email', reservation_customer_email)
  data.append('reservation_payment_amount', reservation_payment_amount)
  data.append('reservation_payment_method', reservation_payment_method)
  data.append('reservation_depositor_name', reservation_depositor_name)
  data.append('reservation_cash_receipt_request', reservation_cash_receipt_request)
  data.append('reservation_request', reservation_request)
  data.append('reservation_terms_of_use', reservation_terms_of_use)
  data.append('reservation_privacy_statement', reservation_privacy_statement)
  data.append('reservation_electronic_terms_and_conditions', reservation_electronic_terms_and_conditions)
  data.append('imp_uid', imp_uid)
  data.append('merchant_uid', merchant_uid)

  try {
    const response = await Axios.post(
      `${base_url}reservation/insert_reservation_immediate`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_one = async (reservation_ID) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_customer_ID = async (customer_ID) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_customer_ID`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_name_phone = async (reservation_customer_name, reservation_customer_phone_number) => {
  let data = new FormData()
  data.append('reservation_customer_name', reservation_customer_name)
  data.append('reservation_customer_phone_number', reservation_customer_phone_number)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_name_phone`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_number = async (params) => {
  let data = new FormData()
  data.append('params', JSON.stringify(params))

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_number`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_number_one = async (reservation_number_ID) => {
  let data = new FormData()
  data.append('reservation_number_ID', reservation_number_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_number_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_dashboard = async (admin_number) => {
  let data = new FormData()
  data.append('admin_number', admin_number)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_dashboard`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_seat_one = async (
  reservation_ID
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_seat_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_reservation_seat_list = async (
  schedule_ID_use_reservation_seat,
  search_list_data
) => {
  let data = new FormData()
  data.append('schedule_ID_use_reservation_seat', schedule_ID_use_reservation_seat)
  data.append('search_list_data', search_list_data)

  try {
    const response = await Axios.post(
      `${base_url}reservation/get_reservation_seat_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const add_reservation_seat_list = async (
  schedule_ID_use_reservation_seat
) => {
  let data = new FormData()
  data.append('schedule_ID_use_reservation_seat', schedule_ID_use_reservation_seat)

  try {
    const response = await Axios.post(
      `${base_url}reservation/add_reservation_seat_list`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation = async (
  reservation_ID,
  reservation_customer_name,
  reservation_customer_phone_number,
  reservation_customer_phone_number_2,
  reservation_customer_email,
  reservation_memo,
  reservation_expected_payment_amount
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)
  data.append('reservation_customer_name', reservation_customer_name)
  data.append('reservation_customer_phone_number', reservation_customer_phone_number)
  data.append('reservation_customer_phone_number_2', reservation_customer_phone_number_2)
  data.append('reservation_customer_email', reservation_customer_email)
  data.append('reservation_memo', reservation_memo)
  data.append('reservation_expected_payment_amount', reservation_expected_payment_amount)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation_payment_complete = async (
  reservation_ID,
  customer_ID_use_reservation,
  reservation_expected_payment_amount,
  reservation_accumulated_points,
  reservation_use_points
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)
  data.append('customer_ID_use_reservation', customer_ID_use_reservation)
  data.append('reservation_expected_payment_amount', reservation_expected_payment_amount)
  data.append('reservation_accumulated_points', reservation_accumulated_points)
  data.append('reservation_use_points', reservation_use_points)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation_payment_complete`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation_payment_cancle = async (
  reservation_ID,
  before_reservation_pay_status,
  reservation_cancle_real_amount,
  customer_ID_use_reservation,
  reservation_accumulated_points,
  reservation_use_points
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)
  data.append('before_reservation_pay_status', before_reservation_pay_status)
  data.append('reservation_cancle_real_amount', reservation_cancle_real_amount)
  data.append('customer_ID_use_reservation', customer_ID_use_reservation)
  data.append('reservation_accumulated_points', reservation_accumulated_points)
  data.append('reservation_use_points', reservation_use_points)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation_payment_cancle`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation_payment_cancle_card = async (
  reservation_ID,
  before_reservation_pay_status,
  reservation_cancle_real_amount,
  customer_ID_use_reservation,
  reservation_accumulated_points,
  reservation_use_points,
  imp_uid
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)
  data.append('before_reservation_pay_status', before_reservation_pay_status)
  data.append('reservation_cancle_real_amount', reservation_cancle_real_amount)
  data.append('customer_ID_use_reservation', customer_ID_use_reservation)
  data.append('reservation_accumulated_points', reservation_accumulated_points)
  data.append('reservation_use_points', reservation_use_points)
  data.append('imp_uid', imp_uid)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation_payment_cancle_card`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation_cancellation_request = async (
  reservation_ID
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation_cancellation_request`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation_cancellation_complete = async (
  reservation_ID
) => {
  let data = new FormData()
  data.append('reservation_ID', reservation_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation_cancellation_complete`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_reservation_seat = async (
  reservation_seat_ID,
  reservation_seat_customer_birthday,
  reservation_seat_customer_gender,
  reservation_seat_customer_name,
  reservation_seat_customer_phone_number,
  reservation_seat_departure_station,
  reservation_seat_name
) => {
  let data = new FormData()
  data.append('reservation_seat_ID', reservation_seat_ID)
  data.append('reservation_seat_customer_birthday', reservation_seat_customer_birthday)
  data.append('reservation_seat_customer_gender', reservation_seat_customer_gender)
  data.append('reservation_seat_customer_name', reservation_seat_customer_name)
  data.append('reservation_seat_customer_phone_number', reservation_seat_customer_phone_number)
  data.append('reservation_seat_departure_station', reservation_seat_departure_station)
  data.append('reservation_seat_name', reservation_seat_name)

  try {
    const response = await Axios.post(
      `${base_url}reservation/update_reservation_seat`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_reservation_seat = async (
  reservation_seat_ID,
  reservation_number_ID
) => {
  let data = new FormData()
  data.append('reservation_seat_ID', reservation_seat_ID)
  data.append('reservation_number_ID', reservation_number_ID)

  try {
    const response = await Axios.post(
      `${base_url}reservation/delete_reservation_seat`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_partner = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}footer/get_partner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_partner_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}footer/get_partner_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_partner_one = async (
  partner_ID
) => {
  let data = new FormData()
  data.append('partner_ID', partner_ID)
  try {
    const response = await Axios.post(
      `${base_url}footer/get_partner_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_partner = async (
  partner_name,
  partner_image,
  partner_link,
  partner_status
) => {
  let data = new FormData()
  data.append('partner_name', partner_name)
  data.append('partner_image', partner_image)
  data.append('partner_link', partner_link)
  data.append('partner_status', partner_status)

  try {
    const response = await Axios.post(
      `${base_url}footer/insert_partner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_partner = async (
  partner_ID,
  partner_name,
  partner_image,
  partner_link,
  partner_status
) => {
  let data = new FormData()
  data.append('partner_ID', partner_ID)
  data.append('partner_name', partner_name)
  data.append('partner_image', partner_image)
  data.append('partner_link', partner_link)
  data.append('partner_status', partner_status)

  try {
    const response = await Axios.post(
      `${base_url}footer/update_partner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_partner_order = async (
  partner_order_array
) => {
  let data = new FormData()

  data.append('partner_order_array', JSON.stringify(partner_order_array))
  try {
    const response = await Axios.post(
      `${base_url}footer/update_partner_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_partner = async (
  partner_ID_array
) => {
  let data = new FormData()
  data.append('partner_ID_array', partner_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}footer/delete_partner`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_performance = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}menu/get_performance`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_performance_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}menu/get_performance_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_performance_one = async (
  performance_ID
) => {
  let data = new FormData()
  data.append('performance_ID', performance_ID)
  try {
    const response = await Axios.post(
      `${base_url}menu/get_performance_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_performance = async (
  performance_title,
  performance_sub_title,
  performance_main_image,
  performance_editor,
  performance_editor_mobile,
  performance_status
) => {
  let data = new FormData()
  data.append('performance_title', performance_title)
  data.append('performance_sub_title', performance_sub_title)
  data.append('performance_main_image', performance_main_image)
  data.append('performance_editor', performance_editor)
  data.append('performance_editor_mobile', performance_editor_mobile)
  data.append('performance_status', performance_status)

  try {
    const response = await Axios.post(
      `${base_url}menu/insert_performance`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_performance = async (
  performance_ID,
  performance_title,
  performance_sub_title,
  performance_main_image,
  performance_editor,
  performance_editor_mobile,
  performance_status
) => {
  let data = new FormData()
  data.append('performance_ID', performance_ID)
  data.append('performance_title', performance_title)
  data.append('performance_sub_title', performance_sub_title)
  data.append('performance_main_image', performance_main_image)
  data.append('performance_editor', performance_editor)
  data.append('performance_editor_mobile', performance_editor_mobile)
  data.append('performance_status', performance_status)

  try {
    const response = await Axios.post(
      `${base_url}menu/update_performance`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_performance_order = async (
  performance_order_array
) => {
  let data = new FormData()

  data.append('performance_order_array', JSON.stringify(performance_order_array))
  try {
    const response = await Axios.post(
      `${base_url}menu/update_performance_order`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_performance = async (
  performance_ID_array
) => {
  let data = new FormData()
  data.append('performance_ID_array', performance_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}menu/delete_performance`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_notice = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_notice`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_notice_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_notice_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_notice_table = async (
  notice_search
) => {
  let data = new FormData()
  data.append('notice_search', notice_search)
  try {
    const response = await Axios.post(
      `${base_url}community/get_notice_table`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_notice_one = async (
  notice_ID
) => {
  let data = new FormData()
  data.append('notice_ID', notice_ID)
  try {
    const response = await Axios.post(
      `${base_url}community/get_notice_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_notice_top4 = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_notice_top4`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_notice = async (
  notice_title,
  notice_top_status,
  notice_write,
  notice_editor,
  notice_status
) => {
  let data = new FormData()
  data.append('notice_title', notice_title)
  data.append('notice_top_status', notice_top_status)
  data.append('notice_write', notice_write)
  data.append('notice_editor', notice_editor)
  data.append('notice_status', notice_status)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_notice`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_notice = async (
  notice_ID,
  notice_title,
  notice_top_status,
  notice_write,
  notice_editor,
  notice_status
) => {
  let data = new FormData()
  data.append('notice_ID', notice_ID)
  data.append('notice_title', notice_title)
  data.append('notice_top_status', notice_top_status)
  data.append('notice_write', notice_write)
  data.append('notice_editor', notice_editor)
  data.append('notice_status', notice_status)

  try {
    const response = await Axios.post(
      `${base_url}community/update_notice`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_notice_views_count = async (
  notice_ID
) => {
  let data = new FormData()
  data.append('notice_ID', notice_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/update_notice_views_count`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_notice = async (
  notice_ID_array
) => {
  let data = new FormData()
  data.append('notice_ID_array', notice_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_notice`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_notice_comment = async (
  customer_ID_use_notice_comment,
  notice_ID_use_notice_comment,
  notice_comment_name,
  notice_comment_password,
  notice_comment_content
) => {
  let data = new FormData()
  data.append('customer_ID_use_notice_comment', customer_ID_use_notice_comment)
  data.append('notice_ID_use_notice_comment', notice_ID_use_notice_comment)
  data.append('notice_comment_name', notice_comment_name)
  data.append('notice_comment_password', notice_comment_password)
  data.append('notice_comment_content', notice_comment_content)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_notice_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_notice_comment = async (
  notice_comment_ID
) => {
  let data = new FormData()
  data.append('notice_comment_ID', notice_comment_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_notice_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_review = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_travel_review`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_review_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_travel_review_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_review_table = async (
  travel_review_search
) => {
  let data = new FormData()
  data.append('travel_review_search', travel_review_search)
  try {
    const response = await Axios.post(
      `${base_url}community/get_travel_review_table`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_travel_review_one = async (
  travel_review_ID
) => {
  let data = new FormData()
  data.append('travel_review_ID', travel_review_ID)
  try {
    const response = await Axios.post(
      `${base_url}community/get_travel_review_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_travel_review = async (
  travel_review_title,
  travel_review_top_status,
  travel_review_write,
  travel_review_email,
  travel_review_main_image,
  travel_review_editor,
  travel_review_status
) => {
  let data = new FormData()
  data.append('travel_review_title', travel_review_title)
  data.append('travel_review_top_status', travel_review_top_status)
  data.append('travel_review_write', travel_review_write)
  data.append('travel_review_email', travel_review_email)
  data.append('travel_review_main_image', travel_review_main_image)
  data.append('travel_review_editor', travel_review_editor)
  data.append('travel_review_status', travel_review_status)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_travel_review`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_review = async (
  travel_review_ID,
  travel_review_title,
  travel_review_top_status,
  travel_review_write,
  travel_review_email,
  travel_review_main_image,
  travel_review_editor,
  travel_review_status
) => {
  let data = new FormData()
  data.append('travel_review_ID', travel_review_ID)
  data.append('travel_review_title', travel_review_title)
  data.append('travel_review_top_status', travel_review_top_status)
  data.append('travel_review_write', travel_review_write)
  data.append('travel_review_email', travel_review_email)
  data.append('travel_review_main_image', travel_review_main_image)
  data.append('travel_review_editor', travel_review_editor)
  data.append('travel_review_status', travel_review_status)

  try {
    const response = await Axios.post(
      `${base_url}community/update_travel_review`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_review_views_count = async (
  travel_review_ID
) => {
  let data = new FormData()
  data.append('travel_review_ID', travel_review_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/update_travel_review_views_count`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_travel_review_status = async (
  travel_review_ID,
  travel_review_status
) => {
  let data = new FormData()
  data.append('travel_review_ID', travel_review_ID)
  data.append('travel_review_status', travel_review_status)

  try {
    const response = await Axios.post(
      `${base_url}community/update_travel_review_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_travel_review = async (
  travel_review_ID_array
) => {
  let data = new FormData()
  data.append('travel_review_ID_array', travel_review_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_travel_review`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_travel_review_comment = async (
  customer_ID_use_travel_review_comment,
  travel_review_ID_use_travel_review_comment,
  travel_review_comment_name,
  travel_review_comment_password,
  travel_review_comment_content
) => {
  let data = new FormData()
  data.append('customer_ID_use_travel_review_comment', customer_ID_use_travel_review_comment)
  data.append('travel_review_ID_use_travel_review_comment', travel_review_ID_use_travel_review_comment)
  data.append('travel_review_comment_name', travel_review_comment_name)
  data.append('travel_review_comment_password', travel_review_comment_password)
  data.append('travel_review_comment_content', travel_review_comment_content)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_travel_review_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_travel_review_comment = async (
  travel_review_comment_ID
) => {
  let data = new FormData()
  data.append('travel_review_comment_ID', travel_review_comment_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_travel_review_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_online_inquiry = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_online_inquiry`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_online_inquiry_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_online_inquiry_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_online_inquiry_table = async (
  online_inquiry_search
) => {
  let data = new FormData()
  data.append('online_inquiry_search', online_inquiry_search)
  try {
    const response = await Axios.post(
      `${base_url}community/get_online_inquiry_table`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_online_inquiry_one = async (
  online_inquiry_ID
) => {
  let data = new FormData()
  data.append('online_inquiry_ID', online_inquiry_ID)
  try {
    const response = await Axios.post(
      `${base_url}community/get_online_inquiry_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_online_inquiry = async (
  online_inquiry_title,
  online_inquiry_top_status,
  online_inquiry_write,
  online_inquiry_email,
  online_inquiry_editor,
  online_inquiry_status,
  online_inquiry_security_status
) => {
  let data = new FormData()
  data.append('online_inquiry_title', online_inquiry_title)
  data.append('online_inquiry_top_status', online_inquiry_top_status)
  data.append('online_inquiry_write', online_inquiry_write)
  data.append('online_inquiry_email', online_inquiry_email)
  data.append('online_inquiry_editor', online_inquiry_editor)
  data.append('online_inquiry_status', online_inquiry_status)
  data.append('online_inquiry_security_status', online_inquiry_security_status)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_online_inquiry`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_online_inquiry = async (
  online_inquiry_ID,
  online_inquiry_title,
  online_inquiry_top_status,
  online_inquiry_write,
  online_inquiry_email,
  online_inquiry_editor,
  online_inquiry_status,
  online_inquiry_security_status
) => {
  let data = new FormData()
  data.append('online_inquiry_ID', online_inquiry_ID)
  data.append('online_inquiry_title', online_inquiry_title)
  data.append('online_inquiry_top_status', online_inquiry_top_status)
  data.append('online_inquiry_write', online_inquiry_write)
  data.append('online_inquiry_email', online_inquiry_email)
  data.append('online_inquiry_editor', online_inquiry_editor)
  data.append('online_inquiry_status', online_inquiry_status)
  data.append('online_inquiry_security_status', online_inquiry_security_status)

  try {
    const response = await Axios.post(
      `${base_url}community/update_online_inquiry`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_online_inquiry_views_count = async (
  online_inquiry_ID
) => {
  let data = new FormData()
  data.append('online_inquiry_ID', online_inquiry_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/update_online_inquiry_views_count`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_online_inquiry_status = async (
  online_inquiry_ID,
  online_inquiry_status
) => {
  let data = new FormData()
  data.append('online_inquiry_ID', online_inquiry_ID)
  data.append('online_inquiry_status', online_inquiry_status)

  try {
    const response = await Axios.post(
      `${base_url}community/update_online_inquiry_status`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_online_inquiry = async (
  online_inquiry_ID_array
) => {
  let data = new FormData()
  data.append('online_inquiry_ID_array', online_inquiry_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_online_inquiry`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_online_inquiry_comment = async (
  customer_ID_use_online_inquiry_comment,
  online_inquiry_ID_use_online_inquiry_comment,
  online_inquiry_comment_name,
  online_inquiry_comment_password,
  online_inquiry_comment_content
) => {
  let data = new FormData()
  data.append('customer_ID_use_online_inquiry_comment', customer_ID_use_online_inquiry_comment)
  data.append('online_inquiry_ID_use_online_inquiry_comment', online_inquiry_ID_use_online_inquiry_comment)
  data.append('online_inquiry_comment_name', online_inquiry_comment_name)
  data.append('online_inquiry_comment_password', online_inquiry_comment_password)
  data.append('online_inquiry_comment_content', online_inquiry_comment_content)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_online_inquiry_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_online_inquiry_comment = async (
  online_inquiry_comment_ID
) => {
  let data = new FormData()
  data.append('online_inquiry_comment_ID', online_inquiry_comment_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_online_inquiry_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_frequently_questions = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_frequently_questions`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_frequently_questions_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_frequently_questions_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_frequently_questions_table = async (
  frequently_questions_search
) => {
  let data = new FormData()
  data.append('frequently_questions_search', frequently_questions_search)
  try {
    const response = await Axios.post(
      `${base_url}community/get_frequently_questions_table`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_frequently_questions_one = async (
  frequently_questions_ID
) => {
  let data = new FormData()
  data.append('frequently_questions_ID', frequently_questions_ID)
  try {
    const response = await Axios.post(
      `${base_url}community/get_frequently_questions_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_frequently_questions = async (
  frequently_questions_title,
  frequently_questions_top_status,
  frequently_questions_write,
  frequently_questions_editor,
  frequently_questions_status
) => {
  let data = new FormData()
  data.append('frequently_questions_title', frequently_questions_title)
  data.append('frequently_questions_top_status', frequently_questions_top_status)
  data.append('frequently_questions_write', frequently_questions_write)
  data.append('frequently_questions_editor', frequently_questions_editor)
  data.append('frequently_questions_status', frequently_questions_status)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_frequently_questions`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_frequently_questions = async (
  frequently_questions_ID,
  frequently_questions_title,
  frequently_questions_top_status,
  frequently_questions_write,
  frequently_questions_editor,
  frequently_questions_status
) => {
  let data = new FormData()
  data.append('frequently_questions_ID', frequently_questions_ID)
  data.append('frequently_questions_title', frequently_questions_title)
  data.append('frequently_questions_top_status', frequently_questions_top_status)
  data.append('frequently_questions_write', frequently_questions_write)
  data.append('frequently_questions_editor', frequently_questions_editor)
  data.append('frequently_questions_status', frequently_questions_status)

  try {
    const response = await Axios.post(
      `${base_url}community/update_frequently_questions`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_frequently_questions_views_count = async (
  frequently_questions_ID
) => {
  let data = new FormData()
  data.append('frequently_questions_ID', frequently_questions_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/update_frequently_questions_views_count`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_frequently_questions = async (
  frequently_questions_ID_array
) => {
  let data = new FormData()
  data.append('frequently_questions_ID_array', frequently_questions_ID_array)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_frequently_questions`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_frequently_questions_comment = async (
  customer_ID_use_frequently_questions_comment,
  frequently_questions_ID_use_frequently_questions_comment,
  frequently_questions_comment_name,
  frequently_questions_comment_password,
  frequently_questions_comment_content
) => {
  let data = new FormData()
  data.append('customer_ID_use_frequently_questions_comment', customer_ID_use_frequently_questions_comment)
  data.append('frequently_questions_ID_use_frequently_questions_comment', frequently_questions_ID_use_frequently_questions_comment)
  data.append('frequently_questions_comment_name', frequently_questions_comment_name)
  data.append('frequently_questions_comment_password', frequently_questions_comment_password)
  data.append('frequently_questions_comment_content', frequently_questions_comment_content)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_frequently_questions_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const delete_frequently_questions_comment = async (
  frequently_questions_comment_ID
) => {
  let data = new FormData()
  data.append('frequently_questions_comment_ID', frequently_questions_comment_ID)

  try {
    const response = await Axios.post(
      `${base_url}community/delete_frequently_questions_comment`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const insert_community = async (
  customer_ID,
  community_ID,
  writer,
  email,
  title,
  online_inquiry_security_status,
  editor,
  travel_review_main_image
) => {
  let data = new FormData()
  data.append('customer_ID', customer_ID)
  data.append('community_ID', community_ID)
  data.append('writer', writer)
  data.append('email', email)
  data.append('title', title)
  data.append('online_inquiry_security_status', online_inquiry_security_status)
  data.append('editor', editor)
  data.append('travel_review_main_image', travel_review_main_image)

  try {
    const response = await Axios.post(
      `${base_url}community/insert_community`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const update_community = async (
  pk_id,
  community_ID,
  writer,
  email,
  title,
  online_inquiry_security_status,
  editor,
  travel_review_main_image
) => {
  let data = new FormData()
  data.append('pk_id', pk_id)
  data.append('community_ID', community_ID)
  data.append('writer', writer)
  data.append('email', email)
  data.append('title', title)
  data.append('online_inquiry_security_status', online_inquiry_security_status)
  data.append('editor', editor)
  data.append('travel_review_main_image', travel_review_main_image)

  try {
    const response = await Axios.post(
      `${base_url}community/update_community`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}
export const insert_group_inquiry = async (
  customer_ID_use_group_inquiry,
  group_inquiry_write,
  group_inquiry_phone_number,
  group_inquiry_email,
  group_inquiry_expected_number,
  group_inquiry_start_date,
  group_inquiry_end_date,
  group_inquiry_expected_expenses,
  group_inquiry_desired_area,
  group_inquiry_word_advice
) => {
  let data = new FormData()
  data.append('customer_ID_use_group_inquiry', customer_ID_use_group_inquiry)
  data.append('group_inquiry_write', group_inquiry_write)
  data.append('group_inquiry_phone_number', group_inquiry_phone_number)
  data.append('group_inquiry_email', group_inquiry_email)
  data.append('group_inquiry_expected_number', group_inquiry_expected_number)
  data.append('group_inquiry_start_date', group_inquiry_start_date)
  data.append('group_inquiry_end_date', group_inquiry_end_date)
  data.append('group_inquiry_expected_expenses', group_inquiry_expected_expenses)
  data.append('group_inquiry_desired_area', group_inquiry_desired_area)
  data.append('group_inquiry_word_advice', group_inquiry_word_advice)
  try {
    const response = await Axios.post(
      `${base_url}community/insert_group_inquiry`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_group_inquiry = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_group_inquiry`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_group_inquiry_use = async () => {
  let data = new FormData()
  try {
    const response = await Axios.post(
      `${base_url}community/get_group_inquiry_use`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_group_inquiry_table = async (
  group_inquiry_search
) => {
  let data = new FormData()
  data.append('group_inquiry_search', group_inquiry_search)
  try {
    const response = await Axios.post(
      `${base_url}community/get_group_inquiry_table`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export const get_group_inquiry_one = async (
  group_inquiry_ID
) => {
  let data = new FormData()
  data.append('group_inquiry_ID', group_inquiry_ID)
  try {
    const response = await Axios.post(
      `${base_url}community/get_group_inquiry_one`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true
      }
    )
    return response.data
  } catch (err) {
    console.error(err)
  }
}

export default{
  defaultFunction
}
</script>



// WEBPACK FOOTER //
// src/components/ETC/Axios.vue